export const positionOfResponsible = [
    { id: "SH", name: "Shareholder" },
    { id: "UBO", name: "UBO" },
    { id: "DIR", name: "Director" },
  ];